import React, { Component, useEffect } from 'react';
import { Button, Form, FormControl, Nav, Navbar, Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import logo from './logo.png';

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Link
} from 'react-router-dom';

import Home from '../Pages/Home';
import Banya from '../Pages/Banya';
import Brus from '../Pages/Brus';

const TITLE = 'Конопатка сруба, конопатка бани, кровельные работы, отделочные работы, окосячка проемов';


  

export default class Header extends Component {

  render() {
    return (
      <>
      <Helmet>
        <title>{ TITLE }</title>
      </Helmet>
    
    

      <Router>
      <Routes>
        <Route path="/banya" element={<Banya />}></Route>
        <Route exact path="/" element={<Home />}></Route>
        <Route path="/brus" element={<Brus />}></Route>
        </Routes>
      </Router>
      </>


    );
  }
}
